import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/components/shadcn/dropdown-menu";
import { NewTaskMenuItems } from "./NewTaskButton";
import { headerIconButtonClass } from "./headerButton";
import { HeaderTip } from "./HeaderTip";

export const CreateButton = () => (
  <DropdownMenu>
    <HeaderTip label="Create new">
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label="Create new"
          data-testid="header-create-button"
          className={headerIconButtonClass}
        >
          <FontAwesomeIcon icon={faPlus} size="lg" />
        </button>
      </DropdownMenuTrigger>
    </HeaderTip>
    <DropdownMenuContent align="end" className="min-w-40">
      <NewTaskMenuItems />
    </DropdownMenuContent>
  </DropdownMenu>
);
